import Quill from 'quill';

const Image = Quill.import('formats/image');
const Delta = Quill.import('delta');

interface Range {
  index: number;
  length: number;
}

class ImageHandler {
  quill: any;
  options: any;

  constructor(quill: any, options: any) {
    this.quill = quill;
    this.options = options;

    if (typeof this.options.upload !== 'function') {
      console.warn('[Missing config] upload function that returns a promise is required');
    }

    const toolbar = this.quill.getModule('toolbar');
    toolbar.addHandler('image', () => this.selectLocalImage());
  }

  selectLocalImage() {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files?.[0];
      if (file) {
        const range: Range = this.quill.getSelection(true) || { index: 0, length: 0 };
        try {
          this.quill.updateContents(new Delta().retain(range.index).delete(range.length));
          this.quill.setSelection(range.index, 1);

          const loadingPlaceholder = 'Uploading...';
          this.quill.updateContents(new Delta().retain(range.index).insert({ image: loadingPlaceholder }));

          const url = await this.options.upload(file);
          this.quill.updateContents(
            new Delta()
              .retain(range.index)
              .delete(1)
              .insert({ image: url })
          );
        } catch (error) {
          console.error('Image upload failed:', error);
          this.quill.updateContents(
            new Delta()
              .retain(range.index)
              .delete(1)
          );
        }
      }
    };
  }
}

Quill.register('modules/imageHandler', ImageHandler);
